// @ts-check
import { query } from '@kk/utils';
import { testCommonActivityHtmlString } from './getCurrentCommonActivityHtmlString';

/**
 * 将端外分享链接转换为端内分享链接
 * @param {string} url
 */
export function transferAppUrl(url) {
    let newUrl = url;
    if (testCommonActivityHtmlString(newUrl)) {
        newUrl = query.add(newUrl, 'conf2fullscreen', '1');
        newUrl = query.add(newUrl, 'conf2scrollwhitearea', '1');
        newUrl = query.add(newUrl, 'x5', '33');
        newUrl = query.add(newUrl, 'statusbar', '0');
        newUrl = newUrl.replace(
            `${process.env.VUE_APP_MINI_HOST}`,
            `${process.env.VUE_APP_TOPIC_HOST}`
        );
    }
    if (['staging'].includes(`${process.env.VUE_APP_HOST_ENV}`)) {
        return `${process.env.VUE_APP_TOPIC_HOST}/ads/common-activity${
            newUrl.split('common-activity')[1]
        }`;
    } else {
        return `${process.env.VUE_APP_TOPIC_HOST}/common-activity${
            newUrl.split('common-activity')[1]
        }`;
    }
}
